import { normalizeFcmRegion, type FcmRegion } from '../utils/fcm-region.utils'

/**
 * Filename for the membership-frontend FCM service worker (Nitro route + client registration).
 * Must differ from legacy `firebase-messaging-sw.js` so `sw-cleanup` can unregister the old app
 * without removing the current worker.
 */
export const FCM_SERVICE_WORKER_SCRIPT = 'cp-firebase-messaging-sw'

/** `region` tells the Nitro route which Firebase project to embed in the worker. */
export function fcmServiceWorkerPath(region?: FcmRegion): string {
  const path = `/${FCM_SERVICE_WORKER_SCRIPT}`
  return region ? `${path}?region=${region}` : path
}

export function isFcmServiceWorkerScriptUrl(url: string | undefined | null): boolean {
  if (!url) return false
  try {
    return new URL(url, 'https://service-worker.invalid').pathname === `/${FCM_SERVICE_WORKER_SCRIPT}`
  } catch {
    return false
  }
}

/** Region a registered worker was built for. Workers registered before regions existed are US. */
export function fcmServiceWorkerRegion(url: string | undefined | null): FcmRegion {
  if (!url) return 'us'
  try {
    return normalizeFcmRegion(new URL(url, 'https://service-worker.invalid').searchParams.get('region')) ?? 'us'
  } catch {
    return 'us'
  }
}
